import { Notice } from '@buffer-mono/popcorn'
import type { ErrorState } from '../../hooks/Subscription/types'

import styles from './index.module.css'

import type { JSX } from 'react'

type ErrorProps = {
  isInline?: boolean
  error: ErrorState
}

export const Error = ({ error }: ErrorProps): JSX.Element => (
  <>
    {error && (
      <Notice variant="error" className={styles.error} aria-live="polite">
        <Notice.Text>{error.message}</Notice.Text>
      </Notice>
    )}
  </>
)
